export default {"src":"/_next/static/media/security-compliance.759419ea.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};